<template>
    <div>
        <b-modal :id="modalId"
                 @hidden="onModalHidden()"
                 modal-class="modal-otp"
                 centered
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-body">
                    <div class="otp-title">{{lbl.otp.otp_code}}</div>
                    <div class="text-otp-msg mt-3">{{lbl.otp.otp_and_refcode}}</div>
                    <div class="text-otp-msg">{{refcode}}</div>
                    <div class="text-otp-msg mt-4 mb-2">{{lbl.otp.plz_input_otp}}</div>
                    <div>
                        <label for="input-otp">
                            <div class="d-flex justify-content-center">
                                <div class="box-input-otp">{{otp[0]}}</div>
                                <div class="box-input-otp">{{otp[1]}}</div>
                                <div class="box-input-otp">{{otp[2]}}</div>
                                <div class="box-input-otp">{{otp[3]}}</div>
                                <div class="box-input-otp">{{otp[4]}}</div>
                                <div class="box-input-otp">{{otp[5]}}</div>
                            </div>
                        </label>
                    </div>
                    <input  type="tel"
                            id="input-otp"
                            class="input-otp-dummy"
                            maxlength="6"
                            v-model="otp"
                            @input="onOtpChange()">

                    <div class="text-otp-time" v-if="!isExpireTime">
                        {{lbl.otp.time_remain}} {{timeHelper.displayTime}} {{lbl.otp.minute}}
                    </div>
                    <div class="text-otp-time" v-else @click="resendOtp()">{{lbl.otp.resend_otp}}</div>
                    <div>
                        <button class="btn-red" v-if="!isExpireTime" @click="onSubmitOtp()">{{lbl.default.confirm}}</button>
                        <button class="btn-disabled" v-else>{{lbl.default.confirm}}</button>
                    </div>
                    <div>
                        <button class="btn-link-red" @click="cancelOtp()">{{lbl.default.cancel}}</button>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Locale from "@/helper/locale/locale.js";
// import Util from "@/helper/Utility.js";
import TimerHelper from "@/helper/TimerHelper.js";
//service
import BzbsOtp from "@/core/Otp/service/BzbsOtp.js";
import { ErrorHandler } from "@/core/ErrorApi/ErrorHandler.js";
//mixin
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";

/**
 * ! This file copy form Food Hunt
 * @property {AlertModalController} controller (required) /components/Modal/Controller/AlertModalController.js
 * @property {String} modalId (reqquired)
 */
export default {
    name: "OtpModal",
    props: {
        // busModal: Object,
        controller: Object,
        modalId: String,
    },
    mixins: [ErrorApiMixin],
    data: function() {
        return {
            busModal: null,
            lbl: Locale.getLbl(),

            tel: '',
            otp: '123456',
            refcode: '123456',
            channel: '',

            timeHelper: new TimerHelper(),
            isExpireTime: false,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
        this.timeHelper.initialTimer(60 * 5, null, false, false);
    },
    mounted: function() {
        this.busModal.$on('show', this.show);
        this.busModal.$on('hide', this.hide);
        this.busModal.$on('startOtp', this.startOtp);
        this.busModal.$on('cancelOtp', this.cancelOtp);
    },
    methods: {
        onModalHidden: function() {
            this.controller.sendCallbackHidden({ tag: this.tag });
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk({ tag: this.tag });
        },
        show: function() {
            this.showModal();
        },
        showModal: function() {
            this.$bvModal.show(this.modalId);
        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        },
        //#region otp
        startOtp: async function(config) {
            this.controller.loadingModal.show();
            this.isExpireTime = false;
            this.tel = config.tel;
            this.refcode = '';
            this.otp = '';
            this.channel = config.channel;

            var success = await this.apiRequestOtp();
            if (success) {
                this.controller.loadingModal.hide();
                this.timeHelper.runTimer(() => {
                    this.setTimeout();
                });

                this.showModal();
            }
        },
        apiRequestOtp: async function() {
            return new Promise((resolve, reject) => {
                BzbsOtp.requestOtp(this.tel, null, this.channel)
                    .then((res) => {
                        console.log(res.data);
                        this.refcode = res.data.refcode;
                        resolve(true);
                    })
                    .catch((err) => {
                        this.controller.loadingModal.hide();
                        var errorHandler = new ErrorHandler();
                        errorHandler.onError2128 = () => {
                            this.controller.alertModal
                                .clearText()
                                .setMsg("เบอร์โทรซ้ำ")
                                .show();
                            this.controller.alertModal.onClickOk(() => {
                                this.controller.sendCallbackError(err);
                            });
                        };
                        this.errorApi(err, errorHandler);
                        reject(false);
                    });
            });
        },

        cancelOtp: function() {
            this.timeHelper.stopTimer();
            this.timeHelper.resetTimer();
            this.hide();
            this.controller.sendCallbackCancel();
        },
        onOtpChange: function() {
            this.otp = this.otp.replace(/\D/g, '');
        },

        setTimeout: function() {
            this.timeHelper.stopTimer();
            this.timeHelper.resetTimer();
            this.isExpireTime = true;
        },

        onSubmitOtp: function() {
            if (this.validateOtp()) {
                console.log('otp pass');
                var otpConfig = {
                    tel: this.tel,
                    otp: this.otp,
                    refcode: this.refcode,
                };
                this.controller.sendCallbackSubmitOtp(otpConfig);
            }
        },
        validateOtp: function() {
            if (this.otp.length != 6) {
                var errorMsg = this.lbl.otp.otpLength;
                if (this.otp == '') {
                    errorMsg = this.lbl.otp.requireInput;
                }

                this.hide();
                this.controller.alertModal.clearText()
                        .setMsg(errorMsg)
                        .show();
                this.controller.alertModal.onHidden(() => {
                    this.showModal();
                });
                return false;
            }

            return true;
        },
        resendOtp: async function() {
            this.controller.loadingModal.show();
            this.isExpireTime = false;
            // this.tel = config.tel;
            this.refcode = '';
            this.otp = '';

            await this.apiRequestOtp();

            this.controller.loadingModal.hide();
            this.timeHelper.runTimer(() => {
                this.setTimeout();
            });

            // this.showModal();
        },
        //#endregion otp
    },
}
</script>
<style lang="scss">
    @import "@/style/base/common.scss";
    @import "@/style/modal.scss";
    @import "./style/OtpModal.scss";
</style>



